export const SEARCH_RELEASE = 'release'; // 用于标记后端版本是是正式版本， 前端用于标记是已上线列表还是草稿箱列表/页面
export const SEARCH_ID = 'id';
export const SEARCH_BOT_ID = 'botId';
export const CHAPTER_ID = 'chapterId';

const releaseFlag = 'true';

export const isRelease = (version: string | null) => version === releaseFlag;
